import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";

headerStyles.buttonGridItem = mergeToNew(headerStyles.buttonGridItem, {
    width: [2, 2, 2, 7, 7],
});

headerStyles.titleGridItem = mergeToNew(headerStyles.titleGridItem, {
    width: [10, 10, 10, 5, 5],
});
